import React, { useState } from "react";
import ScheduledServicesCalendarHeader from "./Components/ScheduledServicesCalendarHeader";
import { Container } from "@mui/material";
import ScheduledServicesCalendarCalendar from "./Components/ScheduledServicesCalendarCalendar";
import { RouteComponentProps } from 'react-router-dom';

const ScheduledServicesCalendar: React.FC<RouteComponentProps> = (props) => {
  const goToEquipmentServicesPage = (equipmentId: string) => props.history.push(`/form-equip-services/${equipmentId}/admin-gestao-equip`);
  const [calendarDate, setCalendarDate] = useState<Date>(new Date());
  return(
    <Container maxWidth='lg'>
      <ScheduledServicesCalendarHeader calendarDate={calendarDate} />
      <ScheduledServicesCalendarCalendar calendarDate={calendarDate} setCalendarDate={setCalendarDate} redirect={goToEquipmentServicesPage} />
    </Container>
  );
};

export default ScheduledServicesCalendar;
